"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetLevel = exports.BlueOceanAction = exports.BlueOceanMethod = void 0;
var BlueOceanMethod;
(function (BlueOceanMethod) {
    BlueOceanMethod["getGameList"] = "getGameList";
    BlueOceanMethod["getGame"] = "getGame";
    BlueOceanMethod["createPlayer"] = "createPlayer";
    BlueOceanMethod["playerExists"] = "playerExists";
    BlueOceanMethod["loginPlayer"] = "loginPlayer";
    BlueOceanMethod["logoutPlayer"] = "logoutPlayer";
    BlueOceanMethod["getRoundHistory"] = "getRoundHistory";
    BlueOceanMethod["getFreeRounds"] = "getFreeRounds";
    BlueOceanMethod["addFreeRounds"] = "addFreeRounds";
    BlueOceanMethod["removeFreeRounds"] = "removeFreeRounds";
})(BlueOceanMethod || (exports.BlueOceanMethod = BlueOceanMethod = {}));
var BlueOceanAction;
(function (BlueOceanAction) {
    BlueOceanAction["debit"] = "debit";
    BlueOceanAction["credit"] = "credit";
    BlueOceanAction["balance"] = "balance";
    BlueOceanAction["rollback"] = "rollback";
})(BlueOceanAction || (exports.BlueOceanAction = BlueOceanAction = {}));
var BetLevel;
(function (BetLevel) {
    BetLevel["min"] = "min";
    BetLevel["mid"] = "mid";
    BetLevel["max"] = "max";
})(BetLevel || (exports.BetLevel = BetLevel = {}));
//# sourceMappingURL=blue-ocean.js.map